import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect } from 'react-router'
import styled from 'styled-components'
import { myEventsQuery } from 'components/layout/query'
import Tabs from 'components/Tabs'
import FullPageLoading from 'components/FullPageLoading'
import { logout, myOrganizationsSelector, myOrganizationsStatusSelector } from 'features/auth/authSlice'
import TopNav from 'features/organization/components/TopNav'
import { showErrorNotification } from 'features/notifications/notificationsSlice'
import { GetMyEventsQuery, GetMyEventsQueryVariables } from 'generated/graphql'
import { useQuery } from 'hooks'
import EleventlyLogo from 'assets/Elevently_logo.png'
import { TOP_NAV_HEIGHT } from 'constants/layout'
import { getNodes } from 'graphql/utils'
import { _, colors } from 'utils'
import Organizations from './tabs/Organizations'
import Events from './tabs/Events'

const S = {
    Page: styled.div`
        display: flex;
        justify-content: center;
        width: 100vw;
        height: 100vh;
        background-color: ${colors.pageBackground};
        overflow: auto;
    `,
    Wrapper: styled.div`
        min-height: calc(100vh - ${TOP_NAV_HEIGHT}px);
        width: 940px;
        max-width: 95vw;
        margin: auto;
        margin-top: ${TOP_NAV_HEIGHT}px;
    `,
    Header: styled.div`
        margin-top: 50px;
        margin-bottom: 20px;
        font-weight: bold;
        font-size: 30px;
        color: ${colors.darkOpacity(0.9)};
    `,
}

const DashBoard = () => {
    const myOrganizations = useSelector(myOrganizationsSelector) || []
    const myOrganizationsStatus = useSelector(myOrganizationsStatusSelector)
    const { data, requestStatus: eventsStatus } = useQuery<
        GetMyEventsQuery, GetMyEventsQueryVariables
    >(myEventsQuery, {
        first: 499,
    })
    const events = getNodes(data?.myEvents)
    const dispatch = useDispatch()

    const [selectedTab, setSelectedTab] = useState<string>('organizations')

    useEffect(() => {
        if (events.length && !myOrganizations.length) {
            setSelectedTab('events')
        }
    }, [myOrganizations.length, events.length])

    if (myOrganizationsStatus !== 'succeeded' || eventsStatus !== 'succeeded') {
        return <FullPageLoading />
    }

    if (myOrganizations.length === 0 && events.length === 0) {
        dispatch(logout())
        dispatch(showErrorNotification(_('superhome.notification.no_access')))
        return <Redirect to="/" />
    }

    return (
        <S.Page>
            <TopNav organization={null} logo={EleventlyLogo} />
            <S.Wrapper>
                <S.Header>{_('superhome.header')}</S.Header>
                <Tabs
                    onSelect={setSelectedTab}
                    activeKey={selectedTab}
                    tabs={[
                        {
                            id: 'organizations',
                            name: _('organization.tabs.organization'),
                            Component: () => <Organizations organizations={myOrganizations} />,
                            hidden: myOrganizations.length === 0
                        },
                        {
                            id: 'events',
                            name: _('organization.tabs.events'),
                            Component: () => <Events events={events} organizations={myOrganizations} />,
                            hidden: events.length === 0,
                        },
                    ].filter((e) => !e.hidden)}
                />
            </S.Wrapper>
        </S.Page>
    )
}

export default DashBoard
